<template>
    <div>
        <div class="progress_box">
            <img @click="audioState" :src="play ? pause_img : play_img" alt="">
            <div class="time-text">{{cTime}}</div>
            <div class="bar">
                <div class="progressbar" @click="playMusic" ref="runfatbar">
                    <div class="greenbar" ref="runbar">
                        <span class="yuan" draggable="true"></span>
                    </div>
                </div>
            </div>
            <div class="time-text">{{dTime}}</div>
        </div>
        <div>
            <!-- <audio ref="player" loop :src="audioHttp"></audio> -->
            <audio ref="player" :src="audioHttp"></audio>
        </div>
    </div>
</template>
<script>
export default {
    name: 'AudioPlayer',
    props: ['audioUrl'],
    watch: {
        audioUrl(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.play = false
                this.cTime = '00:00'
                this.dTime = '00:00'
                this.$refs.runbar.style.width = '0%'
                this.audioHttp = this.audioUrl // 音频URL地址
            })
        }
    },
    data() {
        return {
            cTime: '00:00', // 已播放时间
            dTime: '00:00', // 总播放时间
            play: false, // 播放暂停按钮
            audioHttp: '', // 音频链接
            play_img: require('@/common/images/other/play.png'),
            pause_img: require('@/common/images/other/pause.png')
        }
    },
    mounted() {
        this.audioHttp = this.audioUrl // 音频URL地址
        const music = this.$refs.player // 音频所在对象
        const musicBar = this.$refs.runbar // 颜色进度条所在对象
        const musicWidth = this.$refs.runfatbar.offsetWidth // 底部进度条总宽
        // 获得音频加载完成可播放时的处理
        music.addEventListener('canplay', () => {
            const musicTime = music.duration // 获得音频时长
            const branch = Math.floor(musicTime / 60) // 计算音频分钟
            const second = Math.ceil(musicTime % 60) // 计算音频秒
            if (branch < 10 && second < 10) {
                // 四种情况判断音频总时间
                this.dTime = `0${branch}:0${second}`
            } else if (branch < 10) {
                this.dTime = `0${branch}:${second}`
            } else if (second < 10) {
                this.dTime = `${branch}:0${second}`
            } else {
                this.dTime = `${branch}:${second}`
            }
        })
        // 获得音频正在播放时的处理
        music.addEventListener('timeupdate', () => {
            const musicTime = music.duration // 获得音频时长
            const stopTime = music.currentTime // 获得已播放的音频时长
            musicBar.style.width = `${(stopTime / musicTime) * 100}%` // 计算进度条所在比例宽度
            const branch = Math.floor(stopTime / 60) // 计算已播放的音频分钟
            const second = Math.floor(stopTime % 60) // 计算已播放的音频秒
            // 播放结束 重置播放设置
            if (`${(stopTime / musicTime) * 100}%` === '100%') {
                // const music = this.$refs.player // 音频所在对象
                this.$nextTick(() => {
                    this.play = false
                    musicBar.style.width = '0%'
                    this.cTime = '00:00'
                    // music.play() // 播放音乐
                })
            }
            if (branch < 10 && second < 10) {
                // 四种情况判断显示音频以播放时间
                this.cTime = `0${branch}:0${second}`
            } else if (branch < 10) {
                this.cTime = `0${branch}:${second}`
            } else if (second < 10) {
                this.cTime = `${branch}:0${second}`
            } else {
                this.cTime = `${branch}:${second}`
            }
        })
        // 监听颜色进度条是否触摸拖动
        musicBar.addEventListener('touchmove', event => {
            const events = event.targetTouches[0].pageX // 获得触摸拖动的距离
            musicBar.style.width = `${(events / musicWidth) * 100}%` // 计算进度条所在比例宽度
            music.pause() // 触摸拖动时停止播放
        })
        // 监听颜色进度条是否触摸拖动结束
        musicBar.addEventListener('touchend', () => {
            const touwidth = musicBar.offsetWidth / musicWidth // 计算进度条所在比例
            music.currentTime = music.duration * touwidth // 通过所在比例赋值给音频应在的播放时间
            music.play() // 根据播放时间开始播放
            this.play = true // 更改播放暂停按钮为播放
        })
    },
    methods: {
        // 点击进度条事件
        playMusic(e) {
            const music = this.$refs.player // 音频所在对象
            const barWidth = e.pageX / this.$refs.runfatbar.offsetWidth // 计算点击位置相对父元素总宽的比例
            this.$refs.runbar.style.width = `${barWidth * 100}%` // 进度条应所在的比例总宽
            music.currentTime = music.duration * barWidth // 计算点击时应播放所在的时间
            music.play() // 播放音频
            this.play = true // 更改播放暂停按钮为播放
        },
        // 点击播放暂停按钮时间
        audioState() {
            this.play = !this.play // 更改播放暂停按钮状态
            const music = this.$refs.player // 音频所在对象
            if (this.play) {
                music.play() // 播放音乐
            } else {
                music.pause() // 暂停音乐
            }
        },
    },
    computed: {},
    components: {}
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
.progress_box {
    display: flex;
    align-items: center;
    width: 6.86rem;
    height: 0.82rem;
    padding: 0 0.2rem;
    box-sizing: border-box;
    &>img {
        width: 0.62rem;
        height: 0.62rem;
        margin-right: 0.12rem;
    }
    .bar {
        margin: 0 0.2rem;
        width: 4.18rem;
        .progressbar {
            width: 4.18rem;
            height: 10px;
            background-color: #E5E5E5;
            border-radius: 30px;
            position: relative;
        }
        .greenbar {
            max-width: 4.18rem;
            width: 0%;
            height: 10px;
            border-radius: 30px;
            position: absolute;
            top: 0;
            left: 0;
            background-color: #409EFF;
            .yuan {
                display: inline-block;
                padding: 10px;
                background-color: #ffffff;
                border-radius: 50%;
                position: absolute;
                top: -5px;
                right: -15px;
                box-shadow: 0 0 4px 0 rgba(0,0,0,.3)
            }
        }
    }
}
.time-text {
    display: inline-block;
    box-sizing: border-box;
    color: #909399;
    font-size: 0.22rem;
}
</style>